/**
 * @generated SignedSource<<3500cfecd427ec65579b6a4b3203fec6>>
 * @relayHash 3655b37dd3864d793297734223e1a23d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID afeccd4f43a43f7631a12856b95e0eef6364d7142f3237afc4f7c879052f8ec9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareListEmbedAppQuery } from './JiraSoftwareListEmbedAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareListEmbedAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "afeccd4f43a43f7631a12856b95e0eef6364d7142f3237afc4f7c879052f8ec9",
    "metadata": {},
    "name": "JiraSoftwareListEmbedAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
